import user from "./user";
import userInstitution from "./userInstitution";
import report from "./report";
import group from "./group";
import file from "./file";

const api = () => {
  return {
    user,
    userInstitution,
    report,
    group,
    file,
  };
};

export default api;
